import { render } from "./Company.vue?vue&type=template&id=a00b5a04&scoped=true&ts=true"
import script from "./Company.vue?vue&type=script&lang=ts"
export * from "./Company.vue?vue&type=script&lang=ts"

import "./Company.vue?vue&type=style&index=0&id=a00b5a04&lang=scss&scoped=true"
import "./Company.vue?vue&type=style&index=1&id=a00b5a04&lang=scss&scoped=true"
import "./Company.vue?vue&type=style&index=2&id=a00b5a04&lang=scss&scoped=true"
import "./Company.vue?vue&type=style&index=3&id=a00b5a04&lang=scss&scoped=true"

import exportComponent from "/home/travis/build/indochat/official-website/www.ecomm-cloud.net/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a00b5a04"]])

export default __exports__